import $ from "jquery";

const exportToCSV = function(rows, fileName, extension, separator) {
  if (!rows.length) {
    return;
  }

  const ext = extension ? extension : "tsv";
  const sep = separator ? separator : "\t";

  let csvContent = "data:text/csv;charset=utf-8,";

  rows.forEach(function(item){
    const row = item.join(sep) + "\r\n";
    csvContent += row;
  });

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);

  const name = fileName ? fileName : "csv_download";

  link.setAttribute("download", `${name}_${(new Date).getTime()}.${ext}`);
  document.body.appendChild(link); // Required for FF
  link.click();
  document.body.removeChild(link);
};

const hackyScriptTagExport = function (el) {
  const $target = $(el);
  // Indirect eval: parse the data literal in global scope; avoids esbuild's direct-eval warning.
  const csv = (0, eval)($target.prev().text());

  const fileName = $target.data().fileName;
  const extension = $target.data().extension;
  const separator = $target.data().separator;

  exportToCSV(csv, fileName, extension, separator);
};

window.exportToCSV = exportToCSV;
window.hackyScriptTagExport = hackyScriptTagExport;
